import React, { useEffect, useState } from "react";
import api from "../api";

const ChatButton = ({ defaultValue }) => {
  const [backgroundColor, setBackgroundColor] = useState(null);

  useEffect(() => {
    const cb = async () => {
      const chatbotUuid = localStorage.getItem("chatbot_uuid");
      const { data } = await api.get(`/api/chatbot/${chatbotUuid}`);
      setBackgroundColor(`#${data.chat_color}`);
    };

    cb();
  }, []);

  useEffect(() => {
    setBackgroundColor(defaultValue);
  }, [defaultValue]);

  if (!backgroundColor) return null;
  return (
    <div
      id="support-magic-chat-launcher"
      style={{ backgroundColor }}
      className={`w-[64px] h-[64px] rounded-full flex items-center justify-center cursor-pointer text-white`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width="32"
        height="32"
        strokeWidth="1"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19 14l-7-7-7 7"
        />
      </svg>
    </div>
  );
};

export default ChatButton;
